__turbopack_context__.v({
  "--grid": "photo-flow-gallery-module-scss-module__jS636G__--grid",
  "--has-only-one-entry": "photo-flow-gallery-module-scss-module__jS636G__--has-only-one-entry",
  "--masonry": "photo-flow-gallery-module-scss-module__jS636G__--masonry",
  "__container": "photo-flow-gallery-module-scss-module__jS636G____container",
  "__container--masonry": "photo-flow-gallery-module-scss-module__jS636G____container--masonry",
  "column-blocker": "photo-flow-gallery-module-scss-module__jS636G__column-blocker",
});
